import React from "react"
import useMobileMode from "../../shared/hooks/useMobileMode"
import Layout from "../../shared/components/organisms/layout/layout"
import NextEventContent from "../../components/organisms/next-event-content/next-event-content"
import SEO from "../../shared/components/seo"
import "./../../shared/_shared/Index.scss"

const NextEventTemplate = props => {
    const { isMobile, currentPage } = useMobileMode()
    const webinarInfo = props.pageContext.content
    const seoImg = "https:" + webinarInfo?.imagenPrevisualizacion[0]?.file?.url

    return (
        <Layout isMobile={isMobile} currentPage={currentPage}>
            <SEO
                title={webinarInfo.metaTitulo}
                description={webinarInfo.metaDescripcion.metaDescripcion}
                lang={props.pageContext.language}
                image={seoImg}
            />
            <NextEventContent webinarInfo={webinarInfo} isMobile={isMobile} />
        </Layout>
    )
}

export default NextEventTemplate
